import React from 'react';
import styled from 'styled-components';
import BaseDialog from 'spark-ui/ui-kitchen/ingredients/spices/dialog/BaseDialog';
import DialogTitle from 'spark-ui/ui-kitchen/ingredients/spices/dialog/DialogTitle';
import Button from 'spark-ui/ui-kitchen/ingredients/spices/Button';
import Disclaimer from 'spark-ui/ui-kitchen/ingredients/spices/Disclaimer';
import ActionSpacer from 'spark-ui/ui-kitchen/utensils/ActionSpacer';

const ConfirmationDialogBase = styled(BaseDialog)`
    ${Disclaimer} {
        margin: 1em 0 2em;
    }
`;

const ConfirmationDialog = ({
    open,
    title,
    description,
    confirm = {},
    confirmationOnly,
    cancel,
    size,
    comments={},
    showComments = false
}) => {
    let action;
    let label;
    let disabled;

    if (typeof confirm === 'function') {
        action = confirm;
    } else {
        action = confirm.action;
        label = confirm.label;
        disabled = confirm.disabled;
    }

    return (
        <ConfirmationDialogBase
            open={open}
            onClose={cancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth={size || 'md'}
        >
            <DialogTitle>{title}</DialogTitle>
            <Disclaimer>{description}</Disclaimer>
            {showComments?comments:null}
            <ActionSpacer>
                {!confirmationOnly && (
                    <Button secondary onClick={cancel}>
                        Cancel
                    </Button>
                )}
                <Button primary onClick={action} disabled={disabled}>
                    {label || 'Ok'}
                </Button>
            </ActionSpacer>
        </ConfirmationDialogBase>
    );
};

export default ConfirmationDialog;
